/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/PoolLens.json';
import { PoolLens } from 'libs/contracts/generated/infos/contractTypes';
import { getUniqueContractAddress } from 'libs/contracts/utilities/getUniqueContractAddress';
import { useChainId, useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetPoolLensContractAddressInput {
  chainId: ChainId;
}

export const getPoolLensContractAddress = ({ chainId }: GetPoolLensContractAddressInput) =>
  getUniqueContractAddress({ name: 'PoolLens', chainId });

export const useGetPoolLensContractAddress = () => {
  const { chainId } = useChainId();

  return useMemo(
    () =>
      getPoolLensContractAddress({
        chainId,
      }),
    [chainId],
  );
};

interface GetPoolLensContractInput {
  chainId: ChainId;
  signerOrProvider: Signer | Provider;
}

export const getPoolLensContract = ({ chainId, signerOrProvider }: GetPoolLensContractInput) => {
  const address = getPoolLensContractAddress({ chainId });
  return address ? (new Contract(address, abi, signerOrProvider) as PoolLens) : undefined;
};

interface UseGetPoolLensContractInput {
  passSigner?: boolean;
  chainId?: ChainId;
}

export const useGetPoolLensContract = (input?: UseGetPoolLensContractInput) => {
  const { chainId: currentChainId } = useChainId();
  const chainId = input?.chainId || currentChainId;

  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = input?.passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getPoolLensContract({
            chainId,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, chainId],
  );
};
